import Collapse from 'bootstrap/js/dist/collapse';

function bootstrapCollapses(collapse) {
  const collapseSect = collapse.closest('.collapse-checks-sect');
  if (collapse.collapse) return;

  collapse.collapse = new Collapse(collapse, {
    toggle: false,
  });

  if (!collapseSect) return;

  const trigger = collapseSect.querySelector('.collapse-checks-sect__header');

  trigger.addEventListener('click', () => {
    collapse.collapse.toggle();
  });

  const stickyParent = collapseSect.closest('.sticky-side');

  if (!stickyParent) return;

  const event = new Event('resize');

  ['shown.bs.collapse', 'hidden.bs.collapse'].forEach((eventType) => {
    stickyParent.addEventListener(eventType, () => {
      if (window.matchMedia('(max-width: 991.98px)').matches) return;

      window.dispatchEvent(event);
    });
  });
}

export default function Collapses(collapses) {
  collapses.forEach((collapse) => {
    bootstrapCollapses(collapse);
  });
}
